/**
 * Internal dependencies
 */
import edit from './edit';
import metadata from './block.json';
import save from './save';
import variations from './variations';
import { registerBlockType } from '@wordpress/blocks';
import './style.scss';

const { name } = metadata;

export { metadata, name };

registerBlockType( name, {
	variations,
	/**
	 * @see ./edit.js
	 */
	edit,

	/**
	 * @see ./save.js
	 */
	save,
} );
